import React from "react";
var __jsx = React.createElement;
import { MantineProvider } from "@mantine/core";
import { useThemeStore } from "@/stores/theme";
import { MANTINE_COMPONENTS } from "./mantine-components";
/** Wraps content in a Mantine provider whose colour scheme and field styles follow the SDS theme. */
export function MantineThemeProvider(_ref) {
  var children = _ref.children;
  var isDark = useThemeStore(function (state) {
    return state.isDark;
  });
  return /*#__PURE__*/React.createElement(MantineProvider, {
    theme: {
      colorScheme: isDark ? "dark" : "light",
      primaryColor: "teal",
      defaultRadius: "sm",
      fontFamily: "'IBM Plex Sans', sans-serif",
      components: MANTINE_COMPONENTS
    }
  }, children);
}